import React from "react";
import { Check, Circle, Lock } from "lucide-react";

const StatusIcon = ({ status }) => {
  if (status === "passed") return <Check size={16} aria-label="Passed" />;
  if (status === "open") return <Circle size={12} fill="currentColor" aria-label="Open" />;
  return <Lock size={14} aria-label="Locked" />;
};

export default StatusIcon;
